import React from "react";
import { Inbox, AlertTriangle, RefreshCw } from "lucide-react";

export function EmptyReport({ message = "Belum ada laporan untuk periode yang dipilih." }) {
  return (
    <div className="bg-white border border-dashed border-[hsl(var(--border))] rounded-xl p-8 text-center" data-testid="empty-state">
      <div className="w-14 h-14 rounded-full bg-[hsl(var(--muted))] flex items-center justify-center mx-auto mb-3">
        <Inbox size={24} className="text-[hsl(var(--muted-foreground))]" />
      </div>
      <p className="text-sm text-[hsl(var(--muted-foreground))] font-medium">{message}</p>
    </div>
  );
}

export function ErrorState({ onRetry, message = "Data belum dapat dimuat." }) {
  return (
    <div className="bg-white border border-[#f7c8c8] rounded-xl p-8 text-center" data-testid="error-state">
      <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-3">
        <AlertTriangle size={22} className="text-red-500" />
      </div>
      <p className="text-sm text-[#0e2b26] font-semibold mb-3">{message}</p>
      {onRetry && (
        <button onClick={onRetry} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-[#0e2b26] text-white text-sm font-semibold hover:bg-[#123832]" data-testid="retry-btn">
          <RefreshCw size={14} /> Coba Lagi
        </button>
      )}
    </div>
  );
}

export function LoadingCards({ count = 6 }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-3 sm:gap-4">
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} className="stat-card">
          <div className="skeleton h-3 w-24 mb-3"></div>
          <div className="skeleton h-8 w-20 mb-2"></div>
          <div className="skeleton h-2 w-16"></div>
        </div>
      ))}
    </div>
  );
}
